export const checkValid = ({ category, formData }) => {
  if (category === 'homeServices') {
    const { isDisabledSenior65Plus, isDisabledIndigenous55Plus, hasDementia50Plus, isDisabledIndividual, isFrailElderlyLivingAlone } = formData;
    return isDisabledSenior65Plus || isDisabledIndigenous55Plus || hasDementia50Plus || isDisabledIndividual || isFrailElderlyLivingAlone
  }

  if (category === 'homeNursingCare') {
    const { hasNhiCard, livingAtHome, preciseMedicalNeed, barthelIndexLessThan60, isReceivingPalliativeCare, hasAnyTube } = formData;
    return (
      (hasNhiCard && livingAtHome && isReceivingPalliativeCare) ||
      (hasNhiCard && livingAtHome && hasAnyTube && (preciseMedicalNeed || barthelIndexLessThan60))
    )
  }

  if (category === 'homeMedicalCare') {
    const { hasNhiCard, livingAtHome, preciseMedicalNeed, barthelIndexLessThan60 } = formData;
    return hasNhiCard && livingAtHome && (preciseMedicalNeed || barthelIndexLessThan60)
  }

  if (category === 'homeDentalCare') {
    const { hasNhiCard, regionRestrictedA, livingAtHome, isLongTermBedridden, hasSevereDisability } = formData;
    return hasNhiCard && regionRestrictedA && livingAtHome && (isLongTermBedridden || hasSevereDisability)
  }

  if (category === 'mobileRehabilitation') {
    const { isNotReceivingHomeRehabilitation, notAbleToGoToHospital } = formData;
    return isNotReceivingHomeRehabilitation && notAbleToGoToHospital
  }

  if (category === 'mobileDietitian') {
    const { MNASFScore, isHomeBoundDisabled, isDisabledSenior65PlusOrIndigenous55Plus } = formData;
    return (MNASFScore <= 11 && isHomeBoundDisabled && isDisabledSenior65PlusOrIndigenous55Plus)
  }

  if (category === 'mobilePsychologist') {
    const { BSRSScore, isPatientAgree, notAbleToGoToHospital, distressDescription } = formData;
    return (BSRSScore >= 10 && BSRSScore <= 14 && isPatientAgree && notAbleToGoToHospital && distressDescription)
  }

  if (category === 'mobilePharmacist') {
    const { isMobilityImpairedLivingAlone, isUnableToCollectMedication, notIncludedAboveButHasNeed, reasonMobilePharmacist } = formData;
    return (isMobilityImpairedLivingAlone || isUnableToCollectMedication || (notIncludedAboveButHasNeed && reasonMobilePharmacist))
  }

  return false
}